import { Context, Schema } from "effect"

export const UserId = Schema.Number.pipe(Schema.brand("@superwall/apiUserId"))
export type UserId = Schema.Schema.Type<typeof UserId>

class CurrentUserSchema extends Schema.Class<CurrentUserSchema>("@superwall/api/CurrentUser")({
  userId: UserId,
  roles: Schema.Array(
    Schema.Union(
      Schema.Literal("SUPERADMIN"),
      Schema.Literal("CUSTOMER"),
      Schema.Literal("OWNER"),
      Schema.Literal("ADMIN")
    )
  ),
  permissions: Schema.Array(Schema.String),
}) {}

class CurrentUserContext extends Context.Tag("@superwall/api/CurrentUser")<
  CurrentUserContext,
  CurrentUserSchema
>() {}

const CurrentUserOptional = CurrentUserSchema.pipe(Schema.Option)

class CurrentUserOptionalContext extends Context.Tag("@superwall/api/CurrentUserOptional")<
  CurrentUserOptionalContext,
  typeof CurrentUserOptional.Type
>() {}

export {
  CurrentUserSchema as Schema,
  CurrentUserOptional as OptionalSchema,
  CurrentUserContext as Context,
  CurrentUserOptionalContext as OptionalContext,
}
